import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=cf8cdedc&scoped=true"
import script from "./MessageContent.vue?vue&type=script&lang=js"
export * from "./MessageContent.vue?vue&type=script&lang=js"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=cf8cdedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8cdedc",
  null
  
)

export default component.exports